import { buildHead, SITE_URL } from "@/components/SEO";
import { LEGAL_META } from "@/lib/legalMeta";

/** Shared head() builder for the legal pages. */
export const buildLegalHead = (path: keyof typeof LEGAL_META | string) => {
  const meta = LEGAL_META[path];
  if (!meta) return buildHead({ path });
  const canonical = `${SITE_URL}${path}`;
  return buildHead({
    path,
    title: meta.title,
    description: meta.description,
    canonical,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: meta.name,
      url: canonical,
      inLanguage: "en",
      lastReviewed: meta.effectiveDate,
      publisher: {
        "@type": "Organization",
        name: "GoHub",
        url: SITE_URL,
      },
    },
    breadcrumbs: [
      { name: "Home", url: SITE_URL },
      { name: meta.name, url: canonical },
    ],
  });
};
